import React, { useState } from "react";
import { InfoAction } from "./data";
import CallIcon from "@material-ui/icons/CallOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import DescriptionIcon from "@material-ui/icons/DescriptionOutlined";
import MessageIcon from "@material-ui/icons/MessageOutlined";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import ContactIcon from "@material-ui/icons/PersonOutlineOutlined";
import { EmergencyAlert } from "./EmergencyAlert/EmergencyAlert";

type InfoActionHandler<A extends InfoAction> = (
  a: A,
  i: number,
  classes: any
) => JSX.Element;

export const InfoActionRenderers: {
  [K in InfoAction["action"]]: InfoActionHandler<
    Extract<InfoAction, { action: K }>
  >;
} = {
  call: (a, i, classes) => (
    <a key={i} className={classes.actionButton} href={`tel:${a.number}`}>
      <CallIcon style={{ marginRight: 8 }} />
      <span>{a.number}</span>
    </a>
  ),
  whatsapp: (a, i, classes) => (
    <a
      key={i}
      href={`https://wa.me/${a.number?.replace(/\D/g, "")}`}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.actionButton}
    >
      <WhatsAppIcon style={{ marginRight: 8 }} />
      <span>{a.number}</span>
    </a>
  ),
  pdf: (a, i, classes) => (
    <a
      key={i}
      className={classes.actionButton}
      href={a.url}
      target="_blank"
      rel="noopener noreferrer"
      download={a.url.split("/").pop() || "vedi-file-download"}
    >
      <DescriptionIcon style={{ marginRight: 8 }} />
      <span>{a.label}</span>
    </a>
  ),
  message: (a, i, classes) => (
    <div key={i} className={classes.actionButton} style={{ cursor: "default" }}>
      <MessageIcon style={{ marginRight: 8 }} />
      <span>{a.text}</span>
    </div>
  ),
  url: (a, i, classes) => (
    <a
      key={i}
      className={classes.actionButton}
      href={a.url}
      target="_self"
      rel="noopener noreferrer"
    >
      <DescriptionIcon style={{ marginRight: 8 }} />
      <span>{a.label}</span>
    </a>
  ),
  navigate: (a, i, classes) => (
    <div
      key={i}
      className={classes.actionButton}
      style={{ cursor: "pointer" }}
      data-navigate={a.path}
      data-message={a.message}
    >
      <NavigateNextIcon style={{ marginRight: 8 }} />
      <span>{a.message}</span>
    </div>
  ),
  emergency_alert: (a, i, classes) => {
    const EmergencyAlertButton = () => {
      const [modalOpen, setModalOpen] = useState(false);

      const handleClick = () => {
        setModalOpen(true);
      };

      const handleClose = () => {
        setModalOpen(false);
      };

      return (
        <>
          <div
            key={i}
            className={classes.actionButton}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            <ContactIcon style={{ marginRight: 8 }} />
            <span>Enviar alerta</span>
          </div>
          <EmergencyAlert
            open={modalOpen}
            onClose={handleClose}
            usuario={a.usuario}
          />
        </>
      );
    };

    return <EmergencyAlertButton key={i} />;
  },
};
